module.exports = __webpack_public_path__ + "img/driverLocFree.5b235e67.svg";